module.exports = __webpack_public_path__ + "static/media/close-circle.0764a7dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close-circle.svg
// module id = 319
// module chunks = 1